<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Salary Exchange (Salary Sacrifice)</h1>
    <p>Some employers use something called Salary Exchange (or Salary Sacrifice) for pension contributions.</p>
    <p>This means the employee agrees to give up part of their salary, and in return, the employer pays that amount directly into their pension. It can help both the employee and employer save on National Insurance.</p>
    <p>Not all companies use this method — it depends on how your pension scheme is set up.</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="custom-check">
             <input type="checkbox" v-model="formData.salaryExchange">My company offers Salary Exchange (Salary Sacrifice) for pension contributions
            <span class="checkmark"></span>
        </label>

        <div v-if="formData.salaryExchange" class="cell small-8 sub-panel">
          <br/>
          <p>Some companies choose to reinvest any Employer's National Insurance savings back into the employees pension, or provide the employee the choice to do so with their National Insurance savings.</p>
          <label class="custom-check" >
              <input type="checkbox" v-model="formData.eeReinvestment">My employee's have the option of reinvesting their NI savings into the pension scheme
              <span class="checkmark"></span>
          </label>

          <label class="custom-check">
              <input type="checkbox" v-model="formData.erReinvestment">My company will reinvest our NI savings into the pension scheme
              <span class="checkmark"></span>
          </label>
        </div>

      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, onMounted } from 'vue'

const error = ref(null)

const props = defineProps({
  formData: Object
})


const validateStep = () => {


  return true;
}



const executeStep = async () => {
  return true;
}



onMounted(() => {
});

defineExpose({ validateStep, executeStep });

</script>